import React from "react";
import MediaRenderer from "./MediaRenderer";

/**
 * The body of a `notice` item: the rich text first, then its media (image / PDF / video).
 * Used by the pop-up queue (BroadcastModal) and by the announcement archive page.
 *
 * content_html is sanitised by the server (HtmlPurifier allow-list, SPEC 12.2). The client
 * still strips <script> blocks before the HTML reaches the DOM so a legacy row that was never
 * sanitised can never run code here.
 */

// Removes <script ...>...</script> blocks (any case, any attributes, spaces before the closing
// bracket) and any stray script tag that is left.
const SCRIPT_BLOCK = /<script\b[^>]*>[\s\S]*?<\/script\s*>/gi;
const SCRIPT_TAG = /<\/?script\b[^>]*>/gi;

export const stripScripts = (html) => {
  if (typeof html !== "string" || html === "") return "";
  return html.replace(SCRIPT_BLOCK, "").replace(SCRIPT_TAG, "");
};

const NoticeBody = ({ item, onWatched }) => {
  const html = stripScripts(item ? item.content_html : "");
  const media = item && item.media ? item.media : null;

  return (
    <div className="broadcast-notice">
      <div className="broadcast-notice-body" dangerouslySetInnerHTML={{ __html: html }} />
      {media ? <MediaRenderer media={media} title={item.title} onWatched={onWatched} /> : null}
    </div>
  );
};

export default NoticeBody;
